<template>
  <div class="alert callout error" data-closable role="error-information" style="display:none">
    <p>{{message}}</p>
    <button class="close-button" aria-label="Dismiss alert" type="button" data-close>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
/* global Foundation */
import $ from 'jquery'
export default {
  name: 'error-callout',
  props: ['error'],
  data () {
    return {
    }
  },
  computed: {
    message () {
      return this.error ? this.error.message : ''
    }
  },
  watch: {
    error: 'onErrorChanged'
  },
  methods: {
    onErrorChanged (error) {
      if (error) {
        this.show()
      } else {
        this.hide()
      }
    },
    show: function () {
      Foundation.Motion.animateIn(this.$el, 'fade-in')
    },
    hide: function () {
      $(this.$el).hide()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../sass/foundation-import';
</style>



// WEBPACK FOOTER //
// Callout.vue?6983e879